import { Plant } from '../types';
import { createTokenHeader } from '../utils/functions/headers';
import {
  TGetAllPlantsParams,
  TPlantData,
  TUpdatePlantData,
  TUploadDocument,
  TUploadDocumentResponse,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const plantService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlantsList: builder.query<
      { data: Plant[]; totalCount: number },
      TGetAllPlantsParams
    >({
      query: (params) => ({
        url: 'plant/search',
        method: 'GET',
        params: params,
      }),
      transformResponse: (
        data: Plant[],
        meta: Response
      ) => {
        const totalCount =
          meta.headers.get('X-total-count');
        return {
          data,
          totalCount: Number(totalCount ? totalCount : 0),
        };
      },
    }),
    uploadDocument: builder.mutation<
      TUploadDocumentResponse,
      TUploadDocument
    >({
      query: ({ data, type }) => {
        return {
          url: `plant/document/upload/${type}`,
          method: 'POST',
          data,
          headers: createTokenHeader(),
        };
      },
    }),
    addPlantDetails: builder.mutation<void, TPlantData>({
      query: (data) => {
        return {
          url: 'plant/add',
          method: 'POST',
          data,
        };
      },
    }),
    getPlantDetails: builder.query<TPlantData, string>({
      query: (plantCode) => ({
        method: 'GET',
        url: `plant/details/${plantCode}`,
      }),
    }),
    updatePlantDetails: builder.mutation<
      void,
      TUpdatePlantData
    >({
      query: (data) => {
        return {
          url: 'plant/edit',
          method: 'POST',
          data,
        };
      },
    }),
  }),
});

export const {
  useGetAllPlantsListQuery,
  useUploadDocumentMutation,
  useAddPlantDetailsMutation,
  useGetPlantDetailsQuery,
  useUpdatePlantDetailsMutation,
} = plantService;
